import PushUserConfig from "./PushUserConfig";

export default PushUserConfig;